"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneySchema = void 0;
const zod_1 = require("zod");
const MoneySchema = zod_1.z.object({
    amount: zod_1.z.number(),
    bonusMalusEndOfMonth: zod_1.z.number(),
});
exports.MoneySchema = MoneySchema;
